import { Circle } from 'ol/geom';
import OLFeature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { Feature } from 'ol';
import { transform } from 'ol/proj';
import { getTrueToProjectedRadius } from '../calculateCircleRadius';

const getIdFromShape = (shape: GeoJson): string | null | number => {
  if (shape.properties?.id) {
    return shape.properties.id;
  }

  return null;
};

export const shapeToFeature = (
  shape: GeoJson | undefined | null
): Feature | null => {
  if (!shape) {
    return null;
  }

  let feature: Feature | null = null;
  const id = getIdFromShape(shape);
  if (id && shape.geometry?.type) {
    const geometryType = shape.geometry.type;
    if (geometryType === 'Point' && shape.properties.radius) {
      const [lon, lat] = shape.geometry.coordinates;
      const center = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');

      // The circle in 3857 projection needs to have the projected radius at the given latitude
      //  because of distortion in the projection
      const circle = new Circle(
        center,
        getTrueToProjectedRadius(shape.properties.radius, lat)
      );
      feature = new OLFeature(circle);
    } else {
      // Handle other geometries
      const format = new GeoJSON();
      feature = format.readFeature(shape.geometry, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      });
    }
    if (feature) {
      feature.set('id', id);
      feature.set('name', shape.properties.name || '');
      feature.set('description', shape.properties.description || '');

      Object.entries(shape.properties).forEach(([key, value]) => {
        feature?.set(key, value);
      });
    }
  }

  return feature;
};
